export default __webpack_public_path__ + "static/media/em-banner1-ar.4adcaa74.png";